import Cookies from "js-cookie";

// Set a cookie
export const setCookie = (key: string, value: string, options: Cookies.CookieAttributes = {}): void => {
  Cookies.set(key, value, options);
};

// Get a cookie
export const getCookie = (key: string): string => {
  return Cookies.get(key);
};

// Remove a cookie
export const removeCookie = (key: string): void => {
  Cookies.remove(key);
};
